<template>
  <LayoutHeader main="withdraw" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article>
      <form @submit.prevent="submit()" v-if="step == 'confirm'">
        <h1 class="text-center mb-4">アカウントの閉鎖</h1>

        <div class="mb-2">
          <ul>
            <li>登録情報やウォレット残高が全て削除されます。</li>
            <li>進行中のゲームデータにアクセスできなくなります。（ゲーム内で他のデバイスやプラットフォームとのデータ連携をしている場合はこの限りではありません）</li>
            <li>ログインができなくなります。</li>
            <li>アカウントの復旧はできません。</li>
          </ul>
        </div>

        <div class="mb-3 text-center">
          <label for="agreeCheck">
            <input type="checkbox" class="form-check-input" id="agreeCheck" v-model="agree" required /> 以上に同意しました
          </label>
        </div>
        <div class="mb-5" v-if="agree">
          <button type="submit" class="btn btn-danger w-100 fw-bold">アカウントを閉鎖する</button>
        </div>
        <div class="mb-5" v-else>
          <button type="submit" class="btn btn-danger w-100 fw-bold" disabled>アカウントを閉鎖する (同意してください)</button>
        </div>
        <div class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
        </div>
      </form>
      <div v-else-if="step == 'submited'">
        <h1 class="text-center mb-3">アカウントを閉鎖しました</h1>

        <div class="mb-3">
          TapFunのご利用ありがとうございました。またのお越しをお待ちしております。
        </div>

        <div class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Top' }">ホームへ</router-link>
        </div>
      </div>
    </article>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'アカウントの閉鎖',
      step: this.$route.query.step ?? 'confirm',
      agree: false,
    }
  },
  methods: {
    submit() {
      this.loadingOverlay = true;
      const data = {
        email: this.me.email,
      };
      this.axios({
        url: '/withdraw',
        method: 'post',
        data: data,
      }).then(res => {
        this.session(false);
        this.loadingOverlay = false;
        this.step = 'submited';
      }).catch(e => {
        console.error(e);

        this.loadingOverlay = false;
        alert('通信エラーが発生しました。');
      });
    },
  },
}
</script>
